module.exports = __webpack_public_path__ + "static/media/timer_15.3be5a2c8.svg";